import { Block } from 'baseui/block';
import { ValueDisplay, ValueDisplayWithLabel } from '../../components/ValueDisplay'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'

import { IShiftFunction4Point } from './types'
import { themedUseStyletron } from '../../../theme/customTheme';
import { FormattedMessage } from 'react-intl';

export function OverviewPanel(props: IShiftFunction4Point) {
    const [css, theme] = themedUseStyletron();
    return (
        <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} {...props}>
            <ValueDisplayWithLabel label={<FormattedMessage id='Functions.Output' defaultMessage={'Output'}></FormattedMessage>} value={props.actSetpoint} dimension={'°C'}></ValueDisplayWithLabel>
        </OverviewPanelWrapper>
    );
}